import { FabricImage, Group, type Canvas } from 'fabric';
import { applyAllAttachTo } from '../../layout/utils/attach-to';
import { applyAllChainRecenter } from '../../layout/utils/recenter-chain';
import { arrangeGroup } from '../../grouping/collection/arrange';
import { fitImage } from '../../shared/utils/fit-image';

const applyAllCollections = (canvas: Canvas): void => {
  for (const obj of canvas.getObjects()) {
    if (obj instanceof Group) arrangeGroup(obj);
  }
};

const applyAllImageFits = (canvas: Canvas): void => {
  for (const obj of canvas.getObjects()) {
    if (obj instanceof FabricImage && obj.imageFit && obj.imageFit !== 'none' && obj.imageBox) {
      fitImage(obj, obj.imageFit, obj.imageBox);
    }
  }
};

export const runReflow = (canvas: Canvas): void => {
  applyAllAttachTo(canvas);
  applyAllChainRecenter(canvas);
  applyAllCollections(canvas);
  applyAllImageFits(canvas);
};
